import api from "@/api";
import { buildTermString } from "@/util.js";

const state = {
  carousel: [],
};
const mutations = {
  load(state, banner) {
    state.carousel.push(banner);
    state.carousel.sort((a, b) => a.orderInCarousel - b.orderInCarousel);
  },
};
const actions = {
  init(ctx) {
    const { enabled: priceIncreaseEnabled } =
      ctx.rootState.store.info.price_increase;
    const carousel = ctx.rootState.store.info.store_info.customization?.website
      .banner.carousel.filter(
        (banner) => banner,
      );
    if (carousel.length === ctx.state.carousel.length) return;

    carousel.forEach(async (banner, i) => {
      if (banner.type === "item") {
        const data = await api({
          url: `/123/products?search=${banner.id}&limit=1`,
        });
        banner = data.info.length
          ? structureBannerData({
            type: "item",
            elementData: data.info[0],
            priceIncreaseEnabled,
          })
          : false;
      } else if (banner.type === "department") {
        const data = await getPromise(ctx.rootState.departments, "data");
        const department = data.find(
          (department) => department.category_id === banner.id,
        );
        banner = structureBannerData({
          type: "department",
          elementData: department,
          priceIncreaseEnabled,
        });
      } else if (banner.type === "promotion") {
        const data = await getPromise(
          ctx.rootState.promotions,
          "sharedLibPromos",
        );
        const promotion = data.find((promotion) => promotion.id === banner.id);
        const promotionItemDataResponce = await api({
          url: `/123/products?search=${promotion.upcs[0]}&limit=1`,
        });
        const promotionItemData = promotionItemDataResponce.info.length
          ? promotionItemDataResponce.info[0]
          : null;
        promotion.image = promotionItemData?.image;
        banner = structureBannerData({
          type: "promotion",
          elementData: promotion,
          priceIncreaseEnabled,
        });
      } else if (banner.type === "points") {
        const data = await getPromise(ctx.rootState.store, "info");
        if (data.points_offers?.length) {
          const points = data.points_offers.find(
            (offer) => offer.offering_id === banner.id,
          );
          banner = structureBannerData({
            type: "points",
            elementData: { id: points.offering_id, ...points.xtra },
            priceIncreaseEnabled,
          });
        } else banner = false;
      } else if (banner.type === "club") {
        const data = await getPromise(ctx.rootState.store, "info");
        const clubs = data.coffee_clubs.totals.find(
          (clubs) => clubs.club_id === banner.id,
        );
        banner = structureBannerData({ type: "club", elementData: clubs });
      }
      if (banner) {
        banner.orderInCarousel = i;
        ctx.commit("load", banner);
      }
    });

    function getPromise(state, field) {
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          if (
            state[field]?.length ||
            (state[field] && Object.keys(state[field]).length)
          ) {
            clearInterval(interval);
            resolve(state[field]);
          }
        }, 1000);
      });
    }

    function getIdFieldName(type) {
      switch (type) {
        case "item":
          return "upc";
        case "department":
          return "category_id";
        case "club":
          return "club_id";
        case "points":
          return "id";
        case "promotion":
          return "id";
      }
    }

    function structureBannerData({ type, elementData, priceIncreaseEnabled }) {
      let bannerData;
      switch (type) {
        case "item":
          bannerData = {
            type: "item",
            id: elementData[getIdFieldName("item")],
            name: elementData.name,
            price: elementData.cents / 100,
            size: elementData.size,
            picture_url: elementData.image,
            is_modifier: !!elementData.is_modifier,
            discount: elementData.pricebook_info.promotions.length
              ? elementData.pricebook_info.promotions.length > 1
                ? "Multiple Deals"
                : buildTermString(
                  elementData.byweight,
                  elementData.pricebook_info.promotions[0],
                  priceIncreaseEnabled,
                ).offer
              : null,
            new_product: elementData.new_product,
            product: elementData,
          };
          break;
        case "department":
          bannerData = {
            type: "department",
            id: elementData[getIdFieldName("department")],
            name: elementData.name,
            picture_url: getDepartmentImageAsset(elementData.name),
            sub_departments: elementData.sub_categories &&
              elementData.sub_categories
                .sort((a, b) => b.sort_order - a.sort_order)
                .map((s) => s.name)
                .slice(0, 3),
          };
          break;
        case "club":
          bannerData = {
            type: "club",
            id: elementData[getIdFieldName("club")],
            name: elementData.name,
            picture_url: elementData.image,
            need_to_buy: elementData.min_products,
          };
          break;
        case "points":
          bannerData = {
            type: "points",
            id: elementData[getIdFieldName("points")],
            name: elementData.name,
            points: elementData.points,
            picture_url: elementData.image,
          };
          break;
        case "promotion":
          bannerData = {
            type: "promotion",
            id: elementData[getIdFieldName("promotion")],
            name: elementData.name,
            discount: buildTermString(false, elementData, priceIncreaseEnabled)
              .offer,
            picture_url: elementData.image,
          };
          break;
        case "image":
          bannerData = {
            type: "image",
            image_data: elementData.image_data,
          };
          break;
      }
      return bannerData;
    }

    function getDepartmentImageAsset(name) {
      if (
        ["Party Supply", "Stationery and Print", "Variety", "More"].includes(
          name,
        )
      ) {
        return;
      }
      return require(
        "@/assets/departments/corner/dep_" +
          name.replace(/,| /g, "").toLowerCase() +
          "@3x.png",
      );
    }
  },
};
const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
